import { render, staticRenderFns } from "./tipo-rubricas.vue?vue&type=template&id=6dbd7e06&"
import script from "./tipo-rubricas.vue?vue&type=script&lang=js&"
export * from "./tipo-rubricas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports